import { useTranslation } from "react-i18next";
import { type NeedDto, type NeedPatchDto } from "../../autogen/bff-api";
import { useSaveNow } from "../../common/editing/save-coordinator";
import { ChangeResponsibleButton } from "../../common/persons/ChangeResponsibleButton";
import { hasFieldError } from "./needFieldErrors";

export const ChangeNeedResponsibleButton = ({ need, ownerOrgId }: { need: NeedDto; ownerOrgId: string }) => {
  const { t } = useTranslation();
  const { saveNow, isSaving } = useSaveNow<NeedDto, NeedPatchDto>(need.id);

  return (
    <ChangeResponsibleButton
      ownerOrgId={ownerOrgId}
      departmentId={need.departmentId}
      currentResponsible={need.responsibleBuyer ?? null}
      explanation={t("Only users who may take needs in the need's department are shown.")}
      save={(personId) => saveNow({ responsibleBuyerId: personId })}
      isSaving={isSaving}
      describeFailure={(e) =>
        hasFieldError(e, "zz_FieldErrorCode_NotEligibleResponsibleBuyer")
          ? t("This person may not take needs in the need's department.")
          : null
      }
    />
  );
};
